export function setUser(state, response) {
  state.Usuario = response;
  state.EsLogged = true;
  state.Error = false;
  state.ErrorMessage = "";
}

export function setUsuarios(state, response) {
  state.Usuarios = response;
}

export function setLogin(state, login) {
  state.Login = login;
}

export function logout(state) {
  window.localStorage.removeItem("_token");
  state.Usuario = null;
  state.EsLogged = false;
  state.Usuarios = null;
}
